import { userDetailsApi } from '..';
import { UserDetailsDto } from '../users/dto';

export function getUserDetails() {
  return userDetailsApi.get<UserDetailsDto>('');
}